module.exports = __webpack_public_path__ + "img/OKT.a6a85b6d.png";